import type { ButtonHTMLAttributes } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "../lib/cn";

export interface FilterChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  count?: number;
  icon?: LucideIcon;
  selected?: boolean;
}

/**
 * FilterChip / Category Pill — used for horizontal category scroller on mobile
 * and list selectors. Token-driven across all 4 themes.
 */
export function FilterChip({
  label,
  count,
  icon: Icon,
  selected = false,
  className,
  ...props
}: FilterChipProps) {
  return (
    <button
      type="button"
      className={cn(
        "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-chip text-xs font-semibold whitespace-nowrap transition-all shrink-0 border select-none cursor-pointer",
        selected
          ? "bg-primary text-primary-foreground border-primary shadow-xs"
          : "bg-card text-muted-foreground border-border hover:text-foreground hover:bg-muted/40",
        className
      )}
      {...props}
    >
      {Icon && <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden />}
      <span>{label}</span>
      {count !== undefined && (
        <span
          className={cn(
            "text-[10px] px-1.5 py-0.2 rounded-chip font-bold",
            selected
              ? "bg-primary-foreground/20 text-primary-foreground"
              : "bg-muted text-muted-foreground"
          )}
        >
          {count}
        </span>
      )}
    </button>
  );
}
